import React, { useState} from 'react';
import { getMarkDown } from '../utils';
import GenericDialog from '../dialogs/GenericDialog';
import Footer from '../cards/Footer';
import InfoButton from './InfoButton.js';
import '../../../stylesheets/triagebot/SymptomCommonReason.scss';
import { EVISIT_TEXT_EN, EVISIT_TEXT_ES } from '../commonConstants';

const SymptomCommonReason = ({ message, evisits, setevisits, disabled,setToastMessage }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);
    const [showCommonReasonEVisitChangeOverDialog, setshowCommonReasonEVisitChangeOverDialog] = useState(false);
    const [Isloading,setIsLoading] = useState(false);

    const evisitcommonreasonstext = (message?.data[0]?.evisitcommonreasonstext)
        ? message?.data[0]?.evisitcommonreasonstext
        : '';

    const evisitclickbuttontext = (message?.data[0]?.evisitclickbuttontext)
        ? message?.data[0]?.evisitclickbuttontext
        : '';

        const evisitPopupHeader = (message?.data[0]?.evisitInfo?.textA)
        ? message.data[0].evisitInfo.textA.toString().replace(/[**]/g, '')
        : '';

    const evisitpopupcontent1 = (message?.data[0]?.evisitInfo?.textB)
        ? message.data[0].evisitInfo.textB
        : '';

    const evisitpopupcontent2 = (message?.data[0]?.evisitInfo?.textC)
        ? message.data[0].evisitInfo.textC
        : '';

    const evisitPopupcontact = (message?.data[0]?.evisitInfo?.textD)
        ? message.data[0].evisitInfo.textD
        : '';

    const evisitpopupemergency = (message?.data[0]?.evisitInfo?.textE)
        ? message.data[0].evisitInfo.textE
        : '';

    const closeButton = (message?.buttons[3]?.displayText)    
         ? message?.buttons[3]?.displayText
         : '';
        
  
    const commonReasonData = (message?.data[2])?message.data[2].filter(item => item.cause):[];
    const explicationContent=(evisitpopupcontent1+evisitpopupcontent2+evisitPopupcontact+evisitpopupemergency).replace(/\*\*/g, '');

    const handleClickOpen = () => {
        setIsOpen(true);
    };

    const handleButtonEffect = () => {
        setIsOpen(false);
    }

    const getClickableText = (text) => {
    const regex = new RegExp(`(${EVISIT_TEXT_EN}|${EVISIT_TEXT_ES})`, 'gi');
    const parts = text.split(regex);
    
        return (
            <>
                {parts.map((part, index) => {
                    const lowerPart = part.toLowerCase();
                    if (lowerPart === EVISIT_TEXT_EN.toLowerCase() || lowerPart === EVISIT_TEXT_ES.toLowerCase()) {
                        return (
                            <span key={index} className="clickable" onClick={handleClickOpen}>
                                {part}
                            </span>
                        );
                    }
                    return <React.Fragment key={index}>{part}</React.Fragment>;
                })}
                {
                    (explicationContent && explicationContent!=="none") &&
                    <InfoButton
                        disabled={disabled}
                        header={evisitPopupHeader}
                        ariaText={evisitclickbuttontext}
                        explication={explicationContent}
                        onShowInfo={setToastMessage}
                    />
                }
            </>
        );
    };

    const submitPress = (cause, wdfId) => {
        setIsLoading(true);
        setshowCommonReasonEVisitChangeOverDialog(true);
        const evisitSymptoms = {
            name: cause,
            id: String(wdfId),
            type: "evisitSymptom"
        }
        setevisits([evisitSymptoms]);
        setSelectedButton(cause);
    };


    return (
        <div>
                
            <div className='headerTextCommon'>{getClickableText(evisitclickbuttontext)}</div>
            <div className='instructionsCommon'>{getMarkDown(evisitcommonreasonstext)}</div>
            <div className='button-container'>

                {commonReasonData.map((button, key) => {
                    return (
                        <button
                            key={key}
                            className={`button-item ${selectedButton === button.cause ? 'selected' : ''}`}
                            onClick={() => submitPress(button.cause, button.wdfId)}
                            disabled={disabled}
                        >
                            {button.cause}
                        </button>
                    );
                })}
            </div>

            <GenericDialog
                open={isOpen}
                onClose={handleButtonEffect}
                title={evisitPopupHeader}
                content={
                    <>
                        {getMarkDown(evisitpopupcontent1)}
                        {getMarkDown(evisitpopupcontent2)}
                        <b>{getMarkDown(evisitPopupcontact)}</b>
                        <b>{getMarkDown(evisitpopupemergency)}</b>
                    </>
                }
                actions={
                    <Footer>
                        <button
                            className='button-item'
                            onClick={handleButtonEffect}
                        >
                            {closeButton}
                        </button>
                    </Footer>
                }
            />
            {
                Isloading && <div className="loader">
                <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                </div>
            }

        </div>
    );
};
export default SymptomCommonReason;
